// src/pages/school_exams/template_builder/TemplateDesignerPage.js
import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Paper,
} from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import api from "../../../api";
import TemplateBuilder from "./TemplateBuilder";

const TemplateDesignerPage = () => {
  const [exams, setExams] = useState([]);
  const [selectedExam, setSelectedExam] = useState("");

  useEffect(() => {
    loadExams();
  }, []);

  const loadExams = async () => {
    try {
      const res = await api.get("/exam-management/list");

      if (res.data?.status) {
        setExams(res.data.data || []);
      } else {
        toast.error("Failed to load exams.");
      }
    } catch (err) {
      toast.error("Server error loading exams.");
      console.error(err);
    }
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <ToastContainer />

      {/* Header bar */}
      <Paper
        elevation={1}
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
          borderBottom: "1px solid #e5e7eb",
          bgcolor: "white",
        }}
      >
        <Typography variant="h6" sx={{ mr: 3, fontWeight: 600 }}>
          Marksheet Template Designer
        </Typography>

        <FormControl size="small" sx={{ minWidth: 260 }}>
          <InputLabel>Select Exam</InputLabel>
          <Select
            label="Select Exam"
            value={selectedExam}
            onChange={(e) => setSelectedExam(e.target.value)}
          >
            {exams.map((exam) => (
              <MenuItem key={exam.id} value={exam.id}>
                {exam.exam_name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Paper>

      {/* Body */}
      <Box sx={{ flex: 1 }}>
        {!selectedExam ? (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#9ca3af",
              fontSize: 18,
            }}
          >
            Select an exam to start designing the template.
          </Box>
        ) : (
          <TemplateBuilder examId={selectedExam} />
        )}
      </Box>
    </Box>
  );
};

export default TemplateDesignerPage;
